import React from "react";
import { createRoot } from "react-dom/client";

import { App } from "./App";
import { CacheRefreshProvider } from "@contexts/CacheRefresh";
import { isDevelopment } from "@settings";

import { enableMocking } from "./mocks/start";

const app = isDevelopment ? (
  <App />
) : (
  <CacheRefreshProvider>
    <App />
  </CacheRefreshProvider>
);

void enableMocking().then(() => {
  // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
  createRoot(document.getElementById("root")!).render(
    <React.StrictMode>{app}</React.StrictMode>,
  );
});
